import { cx } from '../../cx'

export type DividerProps = {
  className?: string
  alignment?: 'horizontal' | 'vertical'
}

export const Divider = ({ className, alignment = 'horizontal' }: DividerProps) => (
  <hr
    className={cx(
      'border-primary/15',
      {
        'border-t': alignment === 'horizontal',
        'border-l': alignment === 'vertical',
      },
      className
    )}
  />
)
